import { FC, PropsWithChildren } from 'react';
import { cx } from '@emotion/css';
import { DSIcon, DSText } from '@stihl-design-system/components';

interface ErrorMessageProps extends PropsWithChildren {
  message: string;
  className?: string;
}

export const LoadingErrorMessage: FC<ErrorMessageProps> = ({ className, message }) => (
  <section aria-label={message} aria-live="assertive" className={cx('flex flex-col items-center', className)}>
    <DSIcon name="triangle-exclamationmark-inverted" size="large" />
    <DSText weight="bold" className="mt-3 whitespace-pre-line text-center" data-testid="loadingErrorMessage">
      {message}
    </DSText>
  </section>
);
